export default (props) => (
    /**
    * Icone da ferramenta de Dissolve.
    */
    <svg
        width="25"
        height="21"
        viewBox="0 0 25 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M15.2179 2.40625C15.3141 2.23958 15.5547 2.23958 15.6509 2.40625L22.1214 13.6135C22.2176 13.7802 22.0974 13.9885 21.9049 13.9885H8.96388C8.77143 13.9885 8.65115 13.7802 8.74738 13.6135L15.2179 2.40625Z"
        stroke="#BEC7DC"
        strokeWidth="1.5"
        />
        <rect
        x="1.7334"
        y="8.21094"
        width="12.4441"
        height="11.5145"
        rx="1.25"
        stroke="#BEC7DC"
        strokeWidth="1.5"
        />
    </svg>
);
